<template>
  <v-dialog v-model="show" max-width="766" persistent>
    <v-card max-width="766" color="greyColorLigthTwo" class="rounded-lg">
      <!-- Forms -->
      <v-card-text>
        <v-textarea
          class="pt-6"
          v-model.trim="shareTitle"
          full-width
          color="purple"
          :label="$t('placeHolder.write')"
          :counter="sharedTitleCounter"
          rows="4"
        >
          <template slot="prepend-inner">
            <v-avatar class="mr-3" size="60">
              <v-img :src="$store.state.user.Avatar"></v-img>
            </v-avatar>
          </template>
        </v-textarea>
        <v-combobox
          v-model="selectedTags"
          :items="this.$store.state.tagList"
          :search-input.sync="search"
          deletable-chips
          chip
          color="defaultColor"
          v-on:keyup.enter="addNewTag()"
          class="mt-5"
          hide-selected
          item-text="TagName"
          item-value="Id"
          :label="$t('labels.addTag')"
          multiple
          persistent-hint
          small-chips
          :disabled="this.$store.state.tagListLoading"
          :loading="this.$store.state.tagListLoading"
        >
          <template #selection="{ item, parent }">
            <v-chip
              class="ma-2"
              close
              color="defaultColorLight"
              outlined
              @click:close="parent.selectItem(item)"
            >
              {{ item.TagName }}
            </v-chip>
          </template>
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("description.noContent") }}
                  "<strong>{{ search }}</strong
                  >"
                  {{ $t("description.ifTagAdd") }}
                  <kbd>Enter</kbd>
                  {{ $t("description.pressButton") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
        <v-combobox
          v-model="selectedUsers"
          class="mt-5"
          :disabled="isUpdating"
          :loading="isLoadingUsers"
          :items="users"
          :search-input.sync="searchUserName"
          chips
          hide-selected
          hide-no-data
          color="defaultColor"
          :label="$t('labels.addUser')"
          item-text="FullName"
          item-value="Id"
          multiple
        >
          <template #selection="{ item, parent }">
            <v-chip
              class="ma-2"
              close
              color="defaultColorLight"
              outlined
              @click:close="parent.selectItem(item)"
            >
              <v-avatar left>
                <v-img :src="item.Avatar"></v-img>
              </v-avatar>
              {{ item.FullName }}
            </v-chip>
          </template>
          <!-- <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              color="defaultColorLight"
              outlined
              @click="data.select"
              @click:close="removeUser(data.item)"
            >
              <v-avatar left>
                <v-img :src="data.item.Avatar"></v-img>
              </v-avatar>
              {{ data.item.FullName }}
            </v-chip>
          </template> -->
          <template v-slot:item="data">
            <template>
              <v-list-item-avatar>
                <img :src="data.item.Avatar" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title> {{ data.item.FullName }}</v-list-item-title>
                <v-list-item-subtitle
                  v-for="(groupItem, index) in data.item.Groups"
                  :key="index"
                  v-html="groupItem.Name"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-combobox>
        <v-combobox
          v-if="checkBox.post & !updateItem.Id"
          v-model="groupNameModel"
          :items="groupItems"
          class="mt-5"
          hide-selected
          item-text="Name"
          item-value="Id"
          :label="$t('labels.selectGroup')"
          return-object
          persistent-hint
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("description.noContent") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </v-card-text>

      <!-- Photo -->
      <v-card-text v-if="uploadLoading">
        <loading-progress :status="uploadLoading" />
      </v-card-text>
      <v-card-text>
        <v-banner
          single-line
          shaped
          class="mt-0 pa-0"
          v-if="selectedFiles.length > 0"
        >
          <v-col class="mt-0 pa-0">
            <v-container class="mt-0 pa-0" mx-0 px-0 fluid grid-list-xl>
              <v-layout row wrap class="pa-0" v-if="!uploadLoading">
                <v-flex xs2 v-for="(item, index) in selectedFiles" :key="index">
                  <v-hover>
                    <v-img
                      style="border-radius: 8px"
                      width="100%"
                      :aspect-ratio="1 / 1"
                      slot-scope="{ hover }"
                      contain
                      :src="
                        item.ThumbnailUrl
                          ? item.ThumbnailUrl
                          : item.LocalUrl
                          ? item.LocalUrl
                          : require('@/../public/images/ThumbVideo.png').default
                      "
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="transition-fast-in-fast-out image-hover white--text"
                          style="height: 100%"
                        >
                          <v-layout
                            row
                            wrap
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="deleteFile(item.id, index)"
                                  class="ma-0"
                                  icon
                                  v-on="on"
                                  style="z-index: 100"
                                >
                                  <v-icon color="white">mdi-close</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("buttons.delete") }}</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  class="ma-0"
                                  icon
                                  v-on="on"
                                  style="z-index: 100"
                                >
                                  <v-icon color="white">mdi-folder</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ item.FileName }}</span>
                            </v-tooltip>
                          </v-layout>
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-container>
          </v-col>
          <v-col
            align-self="end"
            class="pa-0 defaultColor--text"
            style="text-align: end; font-size: 12px; letter-spacing: 0px"
            v-if="selectedFiles.length > 0"
          >
            {{ fileLength == null ? " " : fileLength + " / " + "10" }}
          </v-col>
        </v-banner>
      </v-card-text>

      <v-divider></v-divider>

      <!-- CheckBox -->
      <v-card-actions v-if="!updateItem.Id" class="py-0">
        <v-checkbox
          class="mr-4"
          v-model="checkBox.post"
          :label="$t('labels.posts')"
          color="defaultColor"
        >
        </v-checkbox>

        <!-- Only SuperAdmin and Admin can create a post in the news. -->
        <v-checkbox
          v-if="this.$store.state.user.Type.toLowerCase() === 'admin' || this.$store.state.user.Type.toLowerCase() === 'superadmin'"
          class="mr-4"
          v-model="checkBox.news"
          :label="$t('labels.news')"
          color="defaultColor"
        >
        </v-checkbox>
          <!-- END -->

        <v-checkbox
          class="mr-4"
          v-model="checkBox.public"
          :label="$t('labels.isPublic')"
          color="defaultColor"
        >
        </v-checkbox>
      </v-card-actions>

      <v-divider></v-divider>

      <!-- Actions -->
      <v-card-actions class="py-5">
        <input
          type="file"
          accept="image/png, image/gif, image/jpeg, video/mp4, video/mov"
          ref="fileInput"
          style="display: none"
          @change="selectFileHandle"
        />
        <v-btn
          v-if="!this.updateItem.ParentPost"
          color="defaultColorLight"
          class="text-capitalize"
          rounded
          
          elevation="0"
          dark
          :disabled="fileLength == 10"
          @click="browseFile"
        >
          <v-icon left dark flat> mdi-image-outline </v-icon>
          {{ $t("buttons.addMedia") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="defaultColor"
          class="white--text text-capitalize"
          text
          :disabled="shareTitle.length > sharedTitleCounter"
          rounded
          @click="closeModal"
        >
          {{ $t("buttons.cancelUpper") }}
        </v-btn>

        <v-btn
          color="defaultColor"
          class="white--text text-capitalize"
          elevation="0"
          :disabled="shareButtonStatus"
          text
          @click="updateItem.Id ? updatePost() :  createPost()"
          :loading="shareLoading"
        >
          {{updateItem.Id ? $t("buttons.save") : $t("buttons.share") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PostService from "../../services/PostService";
import UserService from "../../services/UserService";
import ContentService from "../../services/ContentService";
import GroupService from "../../services/GroupService";
import LoadingProgress from "../General/LoadingProgress.vue";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      shareTitle: "",
      sharedTitleCounter: 250,

      search: null,
      selectedTags: [],

      users: [],
      selectedUsers: [],
      isUpdating: false,
      searchUserName: null,
      isLoadingUsers: false,

      //File modals
      selectedFiles: [],
      selectedFilesUrl: [],
      fileLength: null,
      tempFiles: [],
      fileIds: [],
      uploadLoading: false,

      checkBox: {
        post: this.$store.state.user.Type.toLowerCase() === 'standart' ? true : false,
        news: false,
        publix: false,
      },

      //Groups
      groupNameModel: null,
      groupItems: [],

      shareLoading: false,

      updateItem: {},
    };
  },
  props: {
    visible: Boolean,
  },
  mounted() {
    this.getGroups();
  },
  components: {
    LoadingProgress,
  },
  methods: {
    addNewTag() {
      PostService.addTag(this.selectedTags[this.selectedTags.length - 1])
        .then((res) => {
          this.selectedTags.splice(this.selectedTags.length - 1, 1);
          this.selectedTags.push(res.data);
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        });
    },

    getUsers(userName) {
      UserService.getUsers(userName)
        .then((res) => {
          this.users = res.data.Data;
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          return reject(err);
        })
        .then(() => {
          this.isLoadingUsers = false;
        });
    },

    removeUser(item) {
      const index = this.selectedUsers.indexOf(item.Id);
      if (index >= 0) this.selectedUsers.splice(index, 1);
    },

    createPost() {
      let tags = [];
      this.selectedTags.forEach((element) => {
        tags.push(element.Id);
      });

      let groups = [];
      if (this.groupNameModel) {
        if (this.groupNameModel.Id) {
          groups.push(this.groupNameModel.Id);
        }
      }

      let users = [];
      this.selectedUsers.forEach((element) => {
        users.push(element.Id);
      });

      //Gönderiler
      if (this.checkBox.post) {
        const body = {
          Content: this.shareTitle,
          Privacy: "public",
          FileIds: this.fileIds,
          CategoryIds: [],
          GroupIds: groups,
          TagIds: tags,
          IsPinned: false,
          IsTest: false,
          Type: "individual",
          SendNotification: false,
          Key: "kurumsal_haberler",
          RelatedUserIds: users,
          RelatedGroupIds: [],
          Properties: [],
          IsAllGroups: groups.length > 0 ? false : true,
          IsShareable: this.checkBox.public,
          Status: 20,
        };
        this.createPostService(body);
      }

      //Battan Haberler
      if (this.checkBox.news) {
        const body = {
          Content: this.shareTitle,
          Privacy: "public",
          FileIds: this.fileIds,
          CategoryIds: [],
          GroupIds: [],
          TagIds: tags,
          IsPinned: false,
          IsTest: false,
          Type: "corporate",
          SendNotification: false,
          Key: "kurumsal_haberler",
          RelatedUserIds: users,
          RelatedGroupIds: [],
          Properties: [],
          IsAllGroups: true,
          IsShareable: this.checkBox.public,
          Status: 20,
        };
        this.createPostService(body);
      }
    },

    createPostService(body) {
      this.shareLoading = true;
      PostService.createPost(body)
        .then((res) => {
          this.getPosts().then(() => {
            this.closeModal();
            this.shareLoading = false;
            showSuccess(this.$t("description.successShareContent"));
          });
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          this.shareLoading = false;
        });
    },

    updatePost() {
      let tags = [];
      this.selectedTags.forEach((element) => {
        tags.push(element.Id);
      });

      let groups = [];
      if (this.groupNameModel) {
        if (this.groupNameModel.Id) {
          groups.push(this.groupNameModel.Id);
        }
      }

      let users = [];
      this.selectedUsers.forEach((element) => {
        users.push(element.Id);
      });

      const body = {
        CategoryIds: this.updateItem.CategoryIds,
        Content: this.shareTitle,
        FileIds: this.fileIds,
        GroupIds: this.updateItem.GroupIds,
        Id: this.updateItem.Id,
        IsAllGroups: this.updateItem.IsAllGroups,
        IsPinned: false,
        IsShareable: this.updateItem.IsShareable,
        IsTest: false,
        Key: this.updateItem.Key,
        Privacy: this.updateItem.Privacy,
        Properties: this.updateItem.Properties,
        RelatedGroupIds: this.updateItem.RelatedGroupIds,
        RelatedUserIds: users,
        SendNotification: false,
        SortOrder: this.updateItem.SortOrder,
        Status: this.updateItem.Status,
        TagIds: tags,
        Type: this.updateItem.Type,
      };

      this.shareLoading = true;
      PostService.updatePost(body)
        .then((res) => {
          this.getPosts().then(() => {
            this.closeModal();
            this.shareLoading = false;
            showSuccess(this.$t("description.successShareContent"));
          });
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          this.shareLoading = false;
        });
    },

    closeModal() {
      this.shareTitle = "";

      this.search = null;
      this.selectedTags = [];

      this.users = [];
      this.selectedUsers = [];
      this.isUpdating = false;
      this.searchUserName = null;
      this.isLoadingUsers = false;

      //File modals
      this.selectedFiles = [];
      this.selectedFilesUrl = [];
      this.fileLength = null;
      this.tempFiles = [];
      this.fileIds = [];
      this.uploadLoading = false;

      (this.checkBox = {
        post: false,
        news: false,
        publix: false,
      }),
        //Groups
        (this.groupNameModel = null);

      this.updateItem = {};

      this.setUpdateDialogItem({});

      this.show = false;
    },

    browseFile() {
      this.$refs.fileInput.click();
    },

    selectFileHandle(e) {
      if (e.target.files[0] === undefined) {
      } else {
        if (e.target.files[0].size < 20000000) {
          this.uploadFileCall(e.target.files[0]);
        } else {
          window.showInfo(
            this.$t("description.fileSizeError"),
            "standart",
            "error"
          );
        }
      }
      e.target.value = "";
    },

    //File upload to service
    uploadFile(media, file) {
      console.log('updaload file : ', file)
      if (media === undefined) {
        console.log("Undefined media");
      } else if (media.type == "") {
        console.log("unsupportedMediaType");
      } else {
        this.selectedFiles.push(file);
        this.tempFiles.push(file);
        this.fileIds.push(file.Id);
        this.selectedFilesUrl.push(file.LocalUrl);
        this.fileLength = this.selectedFiles.length;
      }
    },

    //Return file url to send service
    computedUrl(file) {
      return URL.createObjectURL(file);
    },

    //File delete
    deleteFile(fileId, index) {
      this.selectedFiles.splice(index, 1);
      this.selectedFilesUrl.splice(index, 1);
      this.tempFiles.splice(index, 1);
      this.fileIds.splice(index, 1);
      this.fileLength = this.selectedFiles.length;
    },

    uploadFileCall(media) {
      if (media === undefined) {
        showWarning(this.$t("description.unexpected"));
      }
      if (
        media.type == "image/jpeg" ||
        media.type == "image/png" ||
        media.type == "video/mp4"
      ) {
        let formData = new FormData();
        formData.append("Files", media);
        formData.append("Type", "media");
        this.uploadLoading = true;
        ContentService.uploadFile(formData)
          .then((res) => {
            this.uploadFile(media, res.data[0]);
          })
          .catch((err) => {
            console.log(err);
            showError(err);
          })
          .then(() => {
            this.uploadLoading = false;
          });
      } else {
        showWarning(this.$t("description.unexpected"));
      }
    },

    getGroups() {
      GroupService.getGroups()
        .then((res) => {
          this.groupItems = res.data;
          this.groupItems.unshift({
            Id: null,
            Name: "Tümü",
          });
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {});
    },

    setUpdateItem() {
      if (this.$store.state.updateDialogItem.Id) {
        this.updateItem = this.$store.state.updateDialogItem;
        this.setUpdateDialogItem({})
        console.log('update item :' ,this.updateItem)
        this.shareTitle = this.updateItem.Content;
        this.selectedTags = this.updateItem.Tags;
        this.users = this.updateItem.RelatedUsers;
        this.selectedUsers = this.updateItem.RelatedUsers;

        //Files
        this.updateItem.Files.forEach(element => {
          this.selectedFiles.push(element);
          this.tempFiles.push(element);
          this.fileIds.push(element.Id);
          this.selectedFilesUrl.push(element.LocalUrl);
          this.fileLength = this.updateItem.Files.length;
        });
      }
    },

    ...mapActions(["getPosts", "setUpdateDialogItem"]),
  },
  computed: {
    show: {
      get() {
        if (this.visible) this.setUpdateItem();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },

    shareButtonStatus: {
      get() {
        if(this.updateItem.Id){
          if(this.shareTitle.length > this.sharedTitleCounter ||
          this.shareTitle.length <= 0){
            return true;
          }else{
            return false;
          }
        }
        else if (
          this.shareTitle.length > this.sharedTitleCounter ||
          this.shareTitle.length <= 0 ||
          !(this.checkBox.post || this.checkBox.news)
        ) {
          return true;
        } else {
          if (this.uploadLoading) {
            return true;
          } else {
            return false;
          }
        }
      },
      set(value) {
        this.shareButtonStatus = value;
      },
    },
  },
  watch: {
    searchUserName(val) {
      // Items have already been loaded
      //if (this.users.length > 0) return;
      if (!val) return;
      if (val.length < 3) return;

      // Items have already been requested
      if (this.isLoadingUsers) return;

      this.isLoadingUsers = true;

      // Lazily load input items
      this.getUsers(val);
    },
  },
};
</script>
